import React from 'react';
import { Container } from 'reactstrap';
import HorizontalSlider from '~view/widgets/HorizontalSlider';
import ProductListViewItem from '~view/widgets/ProductListViewItem';
import Skeleton from '~view/widgets/Skeleton';

const SkeletonItems: React.FC = () => {
  return (
    <Container>
      <div className="mb-4">
        <Skeleton height={30} width={200} />
      </div>
      <HorizontalSlider xs={2}>
        {[...new Array(10)].map((_, i) => (
          <ProductListViewItem key={i} col={false} border />
        ))}
      </HorizontalSlider>
    </Container>
  );
};

export default SkeletonItems;
